'use client'

// import { IconFacebook, IconGoogle, IconLinkedin } from '@/components/icons'
import { IconGoogle } from '@/components/icons'
import { LoginProviders } from '@/types/projectTypes'
import ExternalAuthButton from './ExternalAuthButton'
import { signInWithGoogle } from '@/lib/auth-utils'
import { useState } from 'react'

const AuthButtonsList = () => {
  const [isLoading, setIsLoading] = useState(false)

  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true)
      await signInWithGoogle()
    } catch (error) {
      console.error('❌ Google sign-in failed:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className='mt-6 flex items-center justify-center'>
        <div className='w-full border-t border-[#EDEDED]'></div>
        <span className='mx-4 text-sm text-gray-500'>Or</span>
        <div className='w-full border-t border-[#EDEDED]'></div>
      </div>

      <div className='mt-6 flex justify-center gap-4'>
        <ExternalAuthButton
          icon={IconGoogle}
          onClick={handleGoogleSignIn}
          disabled={isLoading}
        />
        {/* <ExternalAuthButton
          icon={IconFacebook}
          onClick={() => signInWithPlatform(LoginProviders.FACEBOOK)}
        />
        <ExternalAuthButton
          icon={IconLinkedin}
          onClick={() => signInWithPlatform(LoginProviders.LINKEDIN)}
        /> */}
      </div>
    </>
  )
}

export default AuthButtonsList
